import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const ManagePackage = () => {
  const navigate = useNavigate();

  const [search, setSearch] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [title, setTitle] = useState('');
  const [inputValue, setInputValue] = useState(''); 
  const [totalParameter, setTotalParameter] = useState(''); 
  const [mrp, setMrp] = useState('');
  const [rate, setRate] = useState('');
  const [errorMssg, setErrorMssg] = useState('');

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [packages, setPackages] = useState([]);

  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackageId, setSelectedPackageId] = useState(null);

  const handleReset = () => {
    setSearch(false);
    setTitle('');
    setInputValue('');
    setTotalParameter('');
    setMrp('');
    setRate('');
    setErrorMssg('');
    setFromDate('');
    setToDate('');
    setPackages([]);
    setIsEditing(false);
    setSelectedPackageId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      title,
      description: inputValue,
      mrp,
      rate,
      totalParameter,
    };

    try {
      const url = isEditing
        ? `/api/EditPackage/${selectedPackageId}`
        : '/api/AddPackage';

      const response = await fetch(url, {
        method: isEditing ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setTitle('');
        setInputValue('');
        setTotalParameter('');
        setMrp('');
        setRate('');
        setErrorMssg('');
        setShowModal(false);
        setIsEditing(false);
        setSelectedPackageId(null);

        if (fromDate && toDate) {
          handleDateChange(fromDate, toDate);
        }
      } else {
        setErrorMssg(isEditing ? 'Failed to update package.' : 'Failed to save package.');
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMssg('Something went wrong.');
    }
  };

  const handleDateChange = async (from, to) => {
    if (!from || !to) return;

    try {
      const response = await fetch('/api/ViewPackageForm', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Fromdate: from, Todate: to }),
      });

      if (response.ok) {
        const data = await response.json();
        setPackages(data);
      } else {
        setErrorMssg('Failed to fetch packages.');
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setErrorMssg('Error fetching packages.');
    }
  };

  return (
    <>
      <div className='my-2 mx-3'>
        <div className='row'>
          <div className={search ? 'col-12' : 'd-none'}>
            <div className='row shadow-sm p-3 bg-white rounded align-items-end'>
              <div className='col-12 col-sm-6 col-md-4 mb-2'>
                <TextField
                  label="From Date"
                  type="date"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    handleDateChange(e.target.value, toDate);
                  }}
                  variant="standard"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className='col-12 col-sm-6 col-md-4 mb-2'>
                <TextField
                  label="To Date"
                  type="date"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    handleDateChange(fromDate, e.target.value);
                  }}
                  variant="standard"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className='col-12 col-md-4 mb-2'>
                <Button variant='contained' color='secondary' onClick={handleReset} fullWidth>
                  Reset
                </Button>
              </div>
            </div>
          </div>

          {!search && (
            <div className='col-12 '>
              <p className="habttn" onClick={() => setShowModal(true)}>
                <i className='bi bi-plus fs-3'></i><b>Add Package </b>
              </p>
              <p className="habttn text-primary" onClick={() => setSearch(true)}>
                <i className='bi bi-search fs-5'></i><b>Search Package</b>
              </p>
            </div>
          )}
        </div>
      </div>

      {packages.length > 0 && (
        <div className="container my-4">
          <h4 className="mb-4 text-center text-primary fw-bold">📦 Available Packages</h4>
          <div className="row">
            {packages.map((pkg, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
                <div className="card shadow-sm border-0 h-100">
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title text-primary fw-bold mb-2">
                      <i className="bi bi-box-seam me-2"></i>{pkg.Title}
                    </h5>
                    <p className="card-text text-muted" >
                      <i className="bi bi-text-paragraph me-1"></i>
                      <span className="fw-semibold">Total Parameter:</span> {pkg.TotalParameter}
                    </p>
                    <p className="card-text text-muted" style={{ minHeight: '60px' }}>
                      <i className="bi bi-text-paragraph me-1"></i>
                      <span className="fw-semibold">Description:</span> {pkg.Description}
                    </p>
                    <div className="mt-auto">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="badge bg-info text-dark px-3 py-2">
                          <i className="bi bi-currency-rupee me-1"></i>MRP: ₹{pkg.MRP}
                        </span>
                        <span className="badge bg-success px-3 py-2">
                          <i className="bi bi-tag-fill me-1"></i>Rate: ₹{pkg.Rate}
                        </span>
                      </div>
                      <small className="text-muted">
                        <i className="bi bi-calendar-event me-1"></i> Added on: {pkg.CreatedAt}
                      </small>
                      <div className="mt-3 d-grid">
                        <Button variant="outlined" color="primary" size="small" onClick={() => {
                          setSelectedPackageId(pkg.MPId);
                          setTitle(pkg.Title || '');
                          setInputValue(pkg.Description || '');
                          setTotalParameter(pkg.TotalParameter || '');
                          setMrp(pkg.MRP || '');
                          setRate(pkg.Rate || '');
                          setShowModal(true);
                          setIsEditing(true);
                        }}>
                          Edit
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {showModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
              <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
                <div className="modal-header">
                  <h5 className="modal-title">{isEditing ? 'Edit Package' : 'Add New Package'}</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={() => {
                    setShowModal(false);
                    setIsEditing(false);
                    setSelectedPackageId(null);
                    setErrorMssg('');
                  }}></button>
                </div>
                <form className="p-3" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <TextField
                      label="Package Title"
                      variant="standard"
                      fullWidth
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      label="Total Parameter"
                      variant="standard"
                      fullWidth
                      value={totalParameter}
                      onChange={(e) => setTotalParameter(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <TextField
                      label="Description"
                      variant="standard"
                      fullWidth
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      required
                    />
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-6 mb-3">
                      <TextField
                        label="MRP"
                        variant="standard"
                        fullWidth
                        type="number"
                        value={mrp}
                        onChange={(e) => setMrp(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <TextField
                        label="Rate"
                        variant="standard"
                        fullWidth
                        type="number"
                        value={rate}
                        onChange={(e) => setRate(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  {errorMssg && (
                    <div className="mb-3 text-danger text-center fw-bold">{errorMssg}</div>
                  )}

                  <div className="d-grid">
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                      {isEditing ? 'Update Package' : 'Save Package'}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};

export default ManagePackage;
